import React, { Fragment, useEffect, useRef, useState } from "react";
import classess from "./Gesamt2.module.css";
import { Box } from "@mui/material";
import Icon from "../../assets/C3.png";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import Unicode from "../../components/unicode/Unicode";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import AXIOS from "../../AXIOS";
import Empty from "../../components/empty/Empty";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";

const Gesamt2 = ({ setSubMenu }) => {
  const [Change, setChange] = useState(true);
  const [Add, setAdd] = useState(false);
  const [GR, setGR] = useState("");
  const [EN, setEN] = useState("");
  const [Response, setResponse] = useState(false);
  const REF1 = useRef(null);
  const REF2 = useRef(null);
  const [Result, setResult] = useState([]);
  const [Emptys, setEmptys] = useState(false);
  const [Counter, setCounter] = useState(0);
  const [Edit, setEdit] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    if (GR.length !== 0 && EN.length !== 0) {
      await AXIOS.put(
        `/LBG/FLACHWAGEN/${!Edit ? Result.length : Result[Counter].ID}.json`,
        {
          ID: !Edit ? Result.length : Result[Counter].ID,
          GR: GR.trim(),
          EN: EN.trim(),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            fetchData();
            fetchData();
            setGR("");
            setEN("");
            setAdd(false);
            setResponse(false);
            setEdit(false);
          }
        })
        .catch((err) => {
          setEmptys(true);
        });
    }
  };
  const fetchData = async () => {
    await AXIOS.get("/LBG/FLACHWAGEN.json")
      .then((response) => {
        if (response.status === 200) {
          setResult(response.data);
        }
      })
      .catch((err) => {
        console.warn(err);
        setEmptys(true);
      });
  };
  const Editable = () => {
    setEdit(true);
    setAdd(true);
    setGR(Result[Counter].GR);
    setEN(Result[Counter].EN);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box className={classess.Gesamt2}>
      {/* {Emptys ? (
        <Empty onClick={() => window.location.reload()} />
      ) : (
        <Fragment>
          <img src={Icon} alt="" className={classess.Icon} />
          <span className={classess.Title}>
            Sehen Sie sich alle verfügbaren Karteikarten sorgfältig an!
          </span>
          <Box className={classess.FC} onClick={() => setChange(!Change)}>
            {!Add ? (
              <Fragment>
                {Result.length === 0 ? (
                  "Der Flachwagen ist leer"
                ) : !Change ? (
                  <span className={classess.GR}>{Result[Counter].EN}</span>
                ) : (
                  <span className={classess.EN}>{Result[Counter].GR}</span>
                )}
              </Fragment>
            ) : (
              <Fragment>
                <Unicode
                  Response={Response ? EN : GR}
                  setResponse={Response ? setEN : setGR}
                  textareaRef={Response ? REF2 : REF1}
                />
                <textarea
                  className={classess.textarea}
                  placeholder={
<<<<<<< HEAD
                    Response ? "Betreten Sie Deutsch" : "Betreten Sie Englisch"
=======
                    Response ? "Betreten Sie Englisch" : "Betreten Sie Deutsch"
>>>>>>> ab03a6355b83b1a936dedae7e941fba1a9c407f1
                  }
                  value={Response ? EN : GR}
                  onChange={(e) =>
                    Response ? setEN(e.target.value) : setGR(e.target.value)
                  }
                  ref={Response ? REF2 : REF1}
                />
                {GR.length === 0 ? null : (
                  <SwapHorizRoundedIcon
                    sx={{
                      position: "absolute",
<<<<<<< HEAD
=======
                      marginTop: "10px",
>>>>>>> ab03a6355b83b1a936dedae7e941fba1a9c407f1
                      color: "rgba(180,180,180)",
                      marginLeft: "220px",
                      marginTop: "-100px",
                    }}
                    onClick={() => setResponse(!Response)}
                  />
                )}
                <SaveAltRoundedIcon
                  sx={{
                    marginTop: "10px",
                    color: "#0ead97",
                  }}
                  onClick={handle}
                />
              </Fragment>
            )}
          </Box>
          {!Add ? (
            <Fragment>
              <span className={classess.Footer}>
                <ArrowBackIosRoundedIcon
                  sx={{
                    fontSize: "0.9rem",
                    position: "relative",
                    top: "2px",
                    right: "5px",
                    cursor: "pointer",
                  }}
<<<<<<< HEAD
                  onClick={() => {
                    setCounter((prev) => (prev > 0 ? prev - 1 : prev));
                    setChange(true);
                  }}
=======
                  onClick={() =>
                    setCounter((prev) => (prev > 0 ? prev - 1 : prev))
                  }
>>>>>>> ab03a6355b83b1a936dedae7e941fba1a9c407f1
                />
                ({Counter + 1}-{Result.length})
                <ArrowForwardIosRoundedIcon
                  sx={{
                    fontSize: "0.9rem",
                    position: "relative",
                    top: "2px",
                    left: "5px",
                    cursor: "pointer",
                  }}
<<<<<<< HEAD
                  onClick={() => {
                    setCounter((prev) =>
                      prev < Result.length - 1 ? prev + 1 : prev
                    );
                    setChange(true);
                  }}
=======
                  onClick={() =>
                    setCounter((prev) =>
                      prev < Result.length - 1 ? prev + 1 : prev
                    )
                  }
>>>>>>> ab03a6355b83b1a936dedae7e941fba1a9c407f1
                />
              </span>
              <span className={classess.Footer}>
                <EditNoteRoundedIcon
                  sx={{
                    fontSize: "1.2rem",
                    position: "relative",
                    top: "-23px",
                    left: "-130px",
                    cursor: "pointer",
                  }}
                  onClick={Editable}
                />
              </span>
              <span className={classess.Footer}>
                <AddRoundedIcon
                  sx={{
                    fontSize: "1.2rem",
                    position: "relative",
                    top: "-50px",
                    left: "130px",
                    cursor: "pointer",
                  }}
                  onClick={() => setAdd(true)}
                />
              </span>
            </Fragment>
          ) : (
            <Box className={classess.BTND}>
              <span>
                <ArrowBackRoundedIcon
                  sx={{
                    fontSize: "1.2rem",
                    position: "relative",
                    top: "8px",
                    left: "130px",
                    cursor: "pointer",
                    color: "gray",
                  }}
                  onClick={() => setAdd(false)}
                />
              </span>
            </Box>
          )}
        </Fragment>
      )} */}
    </Box>
  );
};

export default Gesamt2;
